// extracted by mini-css-extract-plugin
module.exports = {"notfound":"styles_notfound__bnF-a","notfound404":"styles_notfound404__SNixr"};